import React from 'react';
import { Modal, Button, Typography, Grid, Card, CardContent, Box } from '@mui/material';
import styles from './MessageModal.module.scss';
import { MessageModalProps } from './types';

export default function MessageModal({
  open,
  onClose,
  onDismiss,
  modalMessage,
  modalTitle,
  goBackButtonText,
  actionButtonText,
  actionButtonFn,
  actionButtonAdditionalFn,
  actionButtonAdditionalText,
  modalContent,
  headerVariant,
  fullWidth,
  noActionButton,
  noButtons,
  actionButtonDisabled,
}: MessageModalProps) {
  return (
    <Modal open={open} onClose={onDismiss ?? onClose} closeAfterTransition className='action-modal'>
      <Grid component='div' container className={styles.modal_container}>
        <Grid
          component='div'
          size={{ xs: 12, sm: fullWidth ? 11 : 8, md: fullWidth ? 11 : 6, lg: fullWidth ? 11 : 4 }}
        >
          <Card>
            <CardContent sx={{ paddingBottom: '16px !important' }}>
              {modalTitle && (
                <Typography variant={headerVariant ? headerVariant : 'h6'} gutterBottom>
                  {modalTitle}
                </Typography>
              )}
              {modalMessage && <Typography>{modalMessage}</Typography>}
              {modalContent && (
                <Box sx={{ maxHeight: '500px', overflow: 'auto' }}>{modalContent}</Box>
              )}
              {!noButtons && (
                <Grid
                  component='div'
                  container
                  style={{
                    justifyContent: 'flex-end',
                    gap: '8px',
                    flexWrap: 'wrap',
                    marginTop: '16px',
                  }}
                >
                  <Button
                    id='messageModalCloseBtn'
                    variant='contained'
                    onClick={onClose}
                    className={
                      noActionButton
                        ? 'btn-default btn-action-basic'
                        : 'btn-default btn-action-basic btn-cancel'
                    }
                  >
                    {goBackButtonText}
                  </Button>
                  {actionButtonAdditionalFn && actionButtonAdditionalText && (
                    <Button
                      id='messageModalActionButtonAdditionalFnBtn'
                      variant='contained'
                      onClick={actionButtonAdditionalFn}
                      className='btn-default btn-action-basic'
                    >
                      {actionButtonAdditionalText}
                    </Button>
                  )}
                  {!noActionButton && (
                    <Button
                      id='messageModalActionButtonFnBtn'
                      variant='contained'
                      onClick={actionButtonFn}
                      className='btn-default btn-action-basic'
                      disabled={actionButtonDisabled}
                    >
                      {actionButtonText}
                    </Button>
                  )}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
}
